<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Investimento"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import InvestimentoServicos from './InvestimentoServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        investimento: {
            type: Object,
            default: () => ({})
        },
        idInvestimentoPrevistoContrato: {
            type: String,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Investimento',
                html: `Confirma a exclusão do Investimento de descrição <b>${this.investimento.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let investimentoDto = {
                contratoId: this.contrato.idContrato,
                idInvestimentoPrevistoContrato: this.idInvestimentoPrevistoContrato
            }
            InvestimentoServicos.excluir(investimentoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterInvestimentosAtualizados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
